import { render } from "./app-footer.vue?vue&type=template&id=66ca59e8"
const script = {}

import "./app-footer.vue?vue&type=style&index=0&id=66ca59e8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__